import AWS from "aws-sdk";

AWS.config.region = "ap-northeast-2";
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: "ap-northeast-2:25cdf0da-0aae-4f62-bdbe-ef74539e70bd",
});

const s3 = new AWS.S3({
  accessKeyId: "AKIA4KSDLYQNMTQ5KHNW",
  secretAccessKey: "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",
});

export default s3;
